import React from "react";

export const PreQuotedLogo = ({
  width = "30",
  height = "30",
  fill = "none",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: "5px" }}
  >
    <path
      d="M2.27959 9.73892C1.48543 10.6259 1.46835 11.9641 2.1972 12.9054C3.64354 14.7734 5.22657 16.3564 7.09458 17.8027C8.03593 18.5317 9.37407 18.5146 10.2611 17.7204C12.6692 15.5642 14.8745 13.3109 17.0027 10.8347C17.2132 10.5898 17.3447 10.2897 17.3743 9.96825C17.5049 8.54675 17.7732 4.4512 16.661 3.33896C15.5488 2.22672 11.4532 2.49507 10.0317 2.62569C9.71024 2.65522 9.41016 2.78684 9.16532 2.99726C6.68909 5.12553 4.43575 7.33083 2.27959 9.73892Z"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
    />
    <path
      d="M6.25 12.083L7.91667 13.7497"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 4.99935L18.3333 1.66602"
      stroke={color}
      stroke-opacity="0.6"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
);
